import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { useStore } from "@/store";

export const HintsPanel = observer(function HintsPanel() {
  const t = useTranslations("hints.items");
  const {
    view,
    hints: { hint },
  } = useStore();

  if (!view.isHintsPanelVisible) {
    return null;
  }

  const key = hint?.key ?? "default";
  const params = hint?.params ?? {};

  return (
    <div className="text-gray-500 text-size-13 leading-4 min-h-17 bg-gray-100 dark:bg-gray-900 p-2.5 mb-1 rounded-8 sm:hidden">
      {/* @ts-expect-error hints could not have a title */}
      {t.has(`${key}.title`) && <h6 className="text-document-text">{t(`${key}.title`)}</h6>}
      <p>
        {t.rich(`${key}.description`, {
          ...params,
          keyButton: (text) => (
            <span className="rounded border bg-document-bg border-gray-300 dark:border-gray-700 px-1">
              {text}
            </span>
          ),
        })}
      </p>
    </div>
  );
});
